import Api from "../services/Api";


// Method to store error detail
export const saveSupportData = async (supportData) => {
  console.log('saveSupportData:', supportData );
  try {
    const response = await Api.post("/support/saveSupportData", supportData);
    console.log({ response });
    if (response.status) {
      return response.payload;
    } else {
      console.log(response.payload ? response.payload : response.message);
      throw new Error(response.payload ? response.payload : response.message);
    }
  } catch (error) {
    console.log(error);
    throw new Error(error.message, { cause: error });
  }
};
